import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import tw, { css, styled } from 'twin.macro'
import useCart from '../../hooks/useCart'
import useTheme from '../../hooks/theme'
import { ChevronDown, ChevronUp, ChevronRight } from 'react-feather'
import AccordionComponent from './accordion'
import { Accordion } from '@reach/accordion'
import '@reach/accordion/styles.css'
import useProduct from '../../hooks/useProduct'
import useWindowResize from '../../hooks/useWindowResize'
import { onAddToCart } from '../utils/analytics'
import Magnifier from 'react-magnifier'
import Spinner from '../utils/spinner'
import { Link, navigate } from 'gatsby'
import { Dialog } from '@headlessui/react'

const windowGlobal = typeof window !== 'undefined' && window

import {
	ProductInfoContainer,
	ProductContainer,
	ProductImageContainer,
	ProductImage,
	ProductImageHolder,
	ProductImagesContainer,
	ProductImageList,
	InfoContainer,
	BreadCrumbsContainer,
	Crumbs,
	SeriesCrumbs,
	ProductTitle,
	Price,
	SKU,
	CtaContainer,
	Button,
	Request,
	BookQuote,
	CompareBtn,
	ControlsContainer,
	IncrementBtn,
	DecrementBtn,
	FssContainer,
	TabsContainer,
	Tab,
	TabDetailsContainer,
	SpecificationsContainer,
	SpecificationsList,
	SpecificationsListItem,
	SpecDetail,
	Spec,
	SupportContainer,
	Manual,
	MSDS,
	WarrantyDownload,
	Brochure,
	Parts,
	SpecInnerItem,
	CircleSvg,
	ProductIframe,
	Stock,
} from './styles'

const ProductInfo = ({
	imageArray,
	brand,
	series,
	model,
	price,
	sku,
	categories,
	shippingClass,
	slug,
	val,
	feature,
	specifications,
	brochure,
	manual,
	msds,
	warrantyDownload,
	distinction,
	tags,
	brandPage,
	title,
	comparisonitem,
	seriesPageDetails,
	degreeView,
	zoom,
	active,
	instock,
	comingSoon,
	linkto,
	checkedLocale,
	currency,
	locale,
}) => {
	const comparison =
		comparisonitem === null ? true : comparisonitem ? true : false
	const { addToCart } = useCart()
	const { openCart } = useTheme()
	const item = {
		img: imageArray[0] != undefined ? imageArray[0].fluid.src : '',
		slug: slug,
		name: title,
		sku: sku,
		price: Number(price * 100),
		quantity: val,
		brand,
		category: [categories && categories.title].toString(),
		shippingClass,
	}
	const [value, setValue] = useState(item)
	const { width } = useWindowResize()
	const images = [
		...imageArray,
		{
			roundview: degreeView,
		},
	]
	const [ActiveProductImage, ReplaceActiveImage] = useState(
		images[0] != undefined ? images[0] : null
	)
	const [imageMap, ReplaceMapped] = useState(images)
	const [features, setFeature] = useState(feature)
	const [activeDetail, setActiveDetail] = useState(0)
	const ItemDetails = [
		{
			name: 'Features',
			active: true,
		},
		{
			name: 'Specifications',
			active: false,
		},
		{
			name: 'Support',
			active: false,
		},
	]

	const [activeTab, setActiveTab] = useState(ItemDetails)

	const changeValueHandler = e => {
		setValue({ ...item, quantity: Number(e.target.value) })
	}

	const incrementHandler = () => {
		setValue(prev => ({ ...item, quantity: Number(prev.quantity) + 1 }))
	}

	const decrementHandler = () => {
		setValue(prev => ({ ...item, quantity: Number(prev.quantity) - 1 }))
	}

	const activeTabHandler = index => {
		let active = activeTab.map((x, i) => {
			return i === index ? { ...x, active: true } : { ...x, active: false }
		})
		setActiveTab(active)
		setActiveDetail(index)
	}

	useEffect(() => {
		const newState = features
			? features.map(feature => {
					return { ...feature, isOpen: false }
			  })
			: null
		setFeature(newState)
	}, [])

	const brochureFile = brochure && brochure[0] && brochure[0].file.url
	const manualFile = manual && manual[0] && manual[0].file.url
	const msdsFile = msds && msds.file.url
	const warrantyFile = warrantyDownload && warrantyDownload.file.url

	const Cb = model ? model.split(' ').indexOf('CB') : ''

	const commercialCheck = tags.includes('commercial')
	const residentialCheck = tags.includes('residential')
	const tagCheck = commercialCheck
		? 'commercial'
		: residentialCheck
		? 'residential'
		: ''

	const { addToTable } = useProduct()
	const checkLength = (key, e, brandPage, tagCheck, title) => {
		const items = windowGlobal.sessionStorage.getItem(key)
		const parsedItems = JSON.parse(items)
		if (width > 1023) {
			if (parsedItems.length >= 3) {
				e.preventDefault()
				if (
					windowGlobal.confirm(`Items to compare cannot be more than 3.
Clicking OK will redirect you to the product comparison page.`)
				) {
					window.location.href = `${checkedLocale}/product-comparison#${key}`
				}
			} else {
				addToTable(brandPage, tagCheck, title)
			}
		} else {
			if (parsedItems.length >= 2) {
				e.preventDefault()
				if (
					windowGlobal.confirm(`Items to compare cannot be more than 2.
Clicking OK will redirect you to the product comparison page.`)
				) {
					window.location.href = `${checkedLocale}/product-comparison#${key}`
				}
			} else {
				addToTable(brandPage, tagCheck, title)
			}
		}
	}

	const [zoomImg, setZoomImg] = useState(
		zoom?.images != undefined ? zoom.images[0] : null
	)

	const [promo, setPromo] = useState(false)
	const [promo150, setPromo150] = useState(false)
	const [promo250, setPromo250] = useState(false)
	const openPromo = () => setPromo(true)
	const openPromo150 = () => setPromo150(true)
	const openPromo250 = () => setPromo250(true)

	const getCountry = locale.split('-')[1].toLowerCase()
	const array = ['spare-parts', 'pool-equipment']
	return (
		<ProductInfoContainer>
			<ProductContainer>
				<ProductImageHolder>
					<ProductImagesContainer>
						<ProductImageList>
							{imageMap.map((image, i) => {
								return image?.roundview === undefined ? (
									<li key={i}>
										<img
											src={image.fluid.src}
											onClick={() => {
												ReplaceActiveImage(imageMap[i])
												setZoomImg(zoom.images[i])
											}}
											onKeyDown={() => {
												ReplaceActiveImage(imageMap[i])
												setZoomImg(zoom.images[i])
											}}
											alt={image.description}
											loading={i === 0 ? 'eager' : 'lazy'}
										/>
									</li>
								) : image?.roundview != null ? (
									<li key={i} className="roundview">
										<p
											onClick={() => ReplaceActiveImage(imageMap[i])}
											onKeyDown={() => ReplaceActiveImage(imageMap[i])}
										>
											360&deg; View
										</p>
									</li>
								) : (
									''
								)
							})}
						</ProductImageList>
					</ProductImagesContainer>
				</ProductImageHolder>
				<ProductImageContainer>
					{ActiveProductImage != null ? (
						ActiveProductImage.roundview != null ||
						ActiveProductImage.roundview != undefined ? (
							<ProductIframe
								src={`${ActiveProductImage.roundview}`}
								id="iframe360"
								frameborder="0"
								scrolling="no"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
								webkitallowfullscreen="true"
								mozallowfullscreen="true"
								allowfullscreen="true"
								loading="lazy"
							></ProductIframe>
						) : (
							<Magnifier
								src={
									ActiveProductImage != null
										? imageArray.length > 0
											? `${
													ActiveProductImage.fluid.src.split('?')[0]
											  }?fm=png&fl=png8&fit=pad&w=450&h=450`
											: ''
										: ''
								}
								zoomImgSrc={
									ActiveProductImage != null
										? imageArray.length > 0
											? `${
													zoomImg.fluid.src.split('?')[0]
											  }?fm=png&fl=png8&fit=pad&w=800&h=800`
											: ''
										: ''
								}
								// mgShowOverflow={false}
								mgWidth={200}
								mgHeight={200}
								zoomFactor={width >= 768 ? 0.8 : 1.1}
								alt={
									ActiveProductImage != null
										? imageArray.length > 0
											? ActiveProductImage.description
											: ''
										: ''
								}
							/>
						)
					) : (
						<Spinner />
					)}
				</ProductImageContainer>
			</ProductContainer>

			<InfoContainer>
				<BreadCrumbsContainer>
					<Crumbs to={`${checkedLocale}/${brandPage ? brandPage.slug : '#'}`}>
						{brand}
					</Crumbs>
					{seriesPageDetails != null ? (
						<>
							{brand != series ? (
								<>
									<ChevronRight width="18px" height="18px" />
									<SeriesCrumbs
										to={`${checkedLocale}/${seriesPageDetails.slug}`}
									>
										{series}
									</SeriesCrumbs>
								</>
							) : (
								''
							)}
						</>
					) : (
						''
					)}
				</BreadCrumbsContainer>
				<ProductTitle>{`${title}`}</ProductTitle>
				<SKU>{sku}</SKU>
				{distinction != null ? (
					series === 'X Line' ? (
						<p tw="text-xs">{distinction}</p>
					) : (
						distinction
					)
				) : (
					''
				)}
				<hr />
				{
					<>
						{series != 'Wave' ? (
							locale === 'en-AU' ? (
								slug !== 'poolside-connect' ? (
									<Price css={tw`mb-2`}>
										{model === 'S 50' && locale === 'en-AU' && (
											<>
												RRP <del>$1249.00</del> On Sale{' '}
											</>
										)}
										{price.toLocaleString(locale, {
											style: 'currency',
											currency: currency,
										})}									
									</Price>		
								) : (
									''
								)
							) : (
								''
							)
						) : (
							''
						)}
					</>
				}
				{
					<>
						{instock === false ? (
							<Stock>
								{comingSoon ? (
									<span>New - Coming Soon</span>
								) : (
									<span className="nostock">Out of Stock</span>
								)}{' '}
								{instock === false ? (
									linkto != undefined || linkto != null ? (
										<>
											– upgrade now to{' '}
											<span
												role="link"
												tabIndex="0"
												className="linkto"
												onClick={() => {
													navigate(`${checkedLocale}/product/${linkto.slug}`)
												}}
												onKeyDown={() => {
													navigate(`${checkedLocale}/product/${linkto.slug}`)
												}}
											>
												{linkto.model}
											</span>
										</>
									) : (
										''
									)
								) : (
									''
								)}
							</Stock>
						) : (
							''
						)}
					</>
				}
				<CtaContainer>
					<>
						{active === null || active === true ? (
							<>
								{series != 'Wave' ? (
									<input
										type="number"
										min={1}
										value={value.quantity < 1 ? '' : value.quantity}
										placeholder="0"
										onChange={e => changeValueHandler(e)}
										onKeyDown={e => changeValueHandler(e)}
									/>
								) : (
									''
								)}
								{series != 'Wave' ? (
									<ControlsContainer>
										<IncrementBtn onClick={() => incrementHandler()}>
											<ChevronUp width="20px" height="20px" />
										</IncrementBtn>
										<DecrementBtn
											disabled={value.quantity <= 1}
											onClick={() => decrementHandler()}
										>
											<ChevronDown width="20px" height="20px" />
										</DecrementBtn>
									</ControlsContainer>
								) : (
									''
								)}
								{series != 'Wave' ? (
									model === 'S 50' ? (
										<Button onClick={openPromo} onKeyDown={openPromo}>
											Add to cart
										</Button>
									) : model === 'S 100' ? (
										<Button onClick={openPromo150} onKeyDown={openPromo150}>
											Add to cart
										</Button>
									) : model === 'S 150' ? (
										<Button onClick={openPromo250} onKeyDown={openPromo250}>
											Add to cart
										</Button>
									) : (
										<Button
											onClick={() => {
												addToCart(value)
												onAddToCart(value, 'Category List')
												openCart()
											}}
											onKeyDown={() => {
												addToCart(value)
												onAddToCart(value, 'Category List')
												openCart()
											}}
											disabled={value.quantity < 1}
										>
											Add to cart
										</Button>
									)
								) : (
									''
								)}
							</>
						) : (
							''
						)}
					</>
				</CtaContainer>

				{categories === null ? (
					<CtaContainer>
						<BookQuote
							css={tw`ml-0`}
							className={
								active === null || active === true
									? series === 'Wave'
										? ''
										: 'alt'
									: ''
							}
							onClick={() => {}}
							onKeyDown={() => {}}
							to={
								active === null || active === true
									? brand != 'Dolphin'
										? `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
												title.toLowerCase()
										  )}#contact-form`
										: series === 'Wave'
										? `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
												model.toLowerCase()
										  )}#contact-form`
										: `${checkedLocale}/book-a-demo`
									: series != 'Wave'
									? `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
											title.toLowerCase()
									  )}#contact-form`
									: `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
											model.toLowerCase()
									  )}#contact-form`
							}
						>
							{active === null || active === true
								? brand != 'Dolphin'
									? 'Get a Quote'
									: series === 'Wave'
									? 'Request a Trial'
									: 'Book a Demo'
								: series === 'Wave'
								? locale === 'en-AU'
									? 'Request a Trial'
									: 'Enquire now'
								: 'Enquire Now'}
						</BookQuote>
						<CompareBtn
							href={
								comparison
									? `${checkedLocale}/product-comparison#${
											brandPage.slug === 'dolphin' ? tagCheck : brandPage.slug
									  }`
									: '#'
							}
							className="alt"
							onClick={e => {
								comparison
									? checkLength(
											brandPage.slug === 'dolphin' ? tagCheck : brandPage.slug,
											e,
											brandPage.slug,
											tagCheck,
											title
									  )
									: ''
							}}
						>
							Compare
						</CompareBtn>
					</CtaContainer>
				) : !array.includes(categories.slug) ? (
					<CtaContainer>
						<BookQuote
							css={tw`ml-0`}
							className={
								active === null || active === true
									? series === 'Wave'
										? ''
										: 'alt'
									: ''
							}
							onClick={() => {}}
							onKeyDown={() => {}}
							to={
								active === null || active === true
									? brand != 'Dolphin'
										? `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
												title.toLowerCase()
										  )}#contact-form`
										: series === 'Wave'
										? `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
												model.toLowerCase()
										  )}#contact-form`
										: `${checkedLocale}/book-a-demo`
									: series != 'Wave'
									? locale === 'en-AU' || series === 'E Line'
										? `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
												title.toLowerCase()
										  )}#contact-form`
										: `https://mydolphin.co.${getCountry}`
									: `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
											model.toLowerCase()
									  )}#contact-form`
							}
						>
							{active === null || active === true
								? brand != 'Dolphin'
									? 'Get a Quote'
									: series === 'Wave'
									? 'Request a Trial'
									: 'Book a Demo'
								: series === 'Wave'
								? locale === 'en-AU'
									? 'Request a Trial'
									: 'Enquire now'
								: locale === 'en-AU' || series === 'E Line'
								? 'Enquire Now'
								: 'Buy at MyDolphin'}
						</BookQuote>
						{brandPage !== null ? (
							<CompareBtn
								href={
									comparison
										? `${checkedLocale}/product-comparison#${
												brandPage.slug === 'dolphin' ? tagCheck : brandPage.slug
										  }`
										: '#'
								}
								className="alt"
								onClick={e => {
									comparison
										? checkLength(
												brandPage.slug === 'dolphin'
													? tagCheck
													: brandPage.slug,
												e,
												brandPage.slug,
												tagCheck,
												title
										  )
										: ''
								}}
							>
								Compare
							</CompareBtn>
						) : (
							''
						)}
					</CtaContainer>
				) : (
					''
				)}
				{comingSoon &&
				instock === false &&
				brandPage &&
				brandPage.slug !== 'dolphin' ? (
					<CtaContainer>
						<BookQuote
							css={tw`ml-0`}
							className={
								active === null || active === true
									? series === 'Wave'
										? ''
										: 'alt'
									: ''
							}
							onClick={() => {}}
							onKeyDown={() => {}}
							to={`${checkedLocale}/support/contact/?subject=ecoclear-pool-equipment#contact-form`}
						>
							Enquire now
						</BookQuote>
					</CtaContainer>
				) : (
					''
				)}

				<FssContainer>
					<TabsContainer>
						{activeTab.map((item, i) => {
							return (
								<Tab
									key={i}
									onClick={() => {
										activeTabHandler(i)
									}}
									className={item.active ? 'active' : ''}
								>
									{item.name}
								</Tab>
							)
						})}
					</TabsContainer>

					<TabDetailsContainer>
						{activeDetail === 0 ? (
							features ? (
								<Accordion collapsible multiple>
									{features.map((item, i) => {
										return (
											<AccordionComponent
												{...{ checkedLocale }}
												item={item}
												key={i}
											/>
										)
									})}
								</Accordion>
							) : brand === 'Eco Clear' ? (
								<p>Nothing under the features</p>
							) : (
								<p>Features not yet available</p>
							)
						) : activeDetail === 1 ? (
							<SpecificationsContainer>
								<SpecificationsList>
									{specifications ? (
										specifications.map((item, i) => {
											return (
												<SpecificationsListItem key={i}>
													<SpecDetail>
														<Spec>{item.spec}:</Spec>{' '}
														{item.detail
															? item.detail
															: item.details.map(val => {
																	return (
																		<SpecInnerItem key={val}>
																			<CircleSvg
																				width="6"
																				height="6"
																				fill="#000"
																			/>
																			{val}
																		</SpecInnerItem>
																	)
															  })}
													</SpecDetail>
												</SpecificationsListItem>
											)
										})
									) : brand === 'Eco Clear' ? (
										<p>Nothing under the specifications</p>
									) : (
										<p>Specification not yet available</p>
									)}
								</SpecificationsList>
							</SpecificationsContainer>
						) : (
							<SupportContainer>
								<Manual href={manualFile} target="_blank">
									Manual
								</Manual>
								<Brochure href={brochureFile} target="_blank">
									Brochure
								</Brochure>
								<Parts
									href={`${checkedLocale}/support/repairs-and-parts/`}
									target="_blank"
								>
									Parts
								</Parts>
								{msdsFile && (
									<MSDS href={msdsFile} target="_blank">
										MSDS
									</MSDS>
								)}

								{warrantyFile && (
									<WarrantyDownload href={warrantyFile} target="_blank">
										Warranty
									</WarrantyDownload>
								)}
							</SupportContainer>
						)}
					</TabDetailsContainer>
				</FssContainer>
			</InfoContainer>
			<Dialog
				open={promo}
				onClose={() => setPromo(false)}
				tw="fixed z-10 inset-0 overflow-y-auto"
			>
				<div tw="flex items-center justify-center min-h-screen">
					<Dialog.Overlay tw="fixed inset-0 bg-black opacity-50" />
					<div
						className="prose"
						tw="relative bg-blue-500 flex rounded-lg items-center mx-6 overflow-hidden"
					>
						<div tw="w-1/3 p-6">
							<img
								src="https://images.ctfassets.net/ftcnv5up9dxv/36uKN4syHo0e3bmvQPB3aF/25f6d43901c1b750c100984ea5b6c378/SModel_Upsell_SocialOnline_D1.png"
								alt="Dolphin S100 Bonus Pack"
								loading="lazy"
							/>
						</div>
						<div tw="bg-white p-6 w-2/3">
							<Dialog.Title tw="font-display font-bold text-2xl text-gray-700 mb-6">
								Upgrade your purchase to a Dolphin S100 Robotic Pool Cleaner!
							</Dialog.Title>
							<Dialog.Description tw="text-lg mb-4">
								Forget about scrubbing floors and walls in your pool – the S100
								does it for you!{' '}
								<b>
									PLUS a FREE Caddy, Caddy Cover, 1 Yr Extended Warranty &
									Delivery!
								</b>
							</Dialog.Description>
							<ul tw="list-disc mb-4 ml-4">
								<li>FREE Caddy (RRP $354)</li>
								<li>FREE Caddy Cover (RRP $113)</li>
								<li>FREE 1 YR Extended Warranty (RRP $102)</li>
								<li>FREE Delivery (RRP $20)</li>
							</ul>
							<p tw="mb-4">
								**<b>Online exclusive offer. Limited time.</b>**
							</p>
							<div tw="flex flex-col md:flex-row space-y-4 md:space-x-4 md:space-y-0">
								<Button
									onClick={() => {
										setPromo(false)
										navigate('/product/dolphin-s-100-bonus')
									}}
								>
									Upgrade Now
								</Button>
								<Button
									onClick={() => {
										addToCart(value)
										onAddToCart(value, 'Category List')
										openCart()
										setPromo(false)
									}}
									tw="bg-white hover:bg-white hover:text-gray-700"
								>
									Continue with S 50 purchase
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Dialog>
			<Dialog
				open={promo150}
				onClose={() => setPromo150(false)}
				tw="fixed z-10 inset-0 overflow-y-auto"
			>
				<div tw="flex items-center justify-center min-h-screen">
					<Dialog.Overlay tw="fixed inset-0 bg-black opacity-50" />
					<div
						className="prose"
						tw="relative bg-blue-500 flex rounded-lg items-center mx-6 overflow-hidden"
					>
						<div tw="w-1/3 p-6">
							<img
								src="https://images.ctfassets.net/ftcnv5up9dxv/36uKN4syHo0e3bmvQPB3aF/25f6d43901c1b750c100984ea5b6c378/SModel_Upsell_SocialOnline_D1.png"
								alt="Dolphin S150 Bonus Pack"
								loading="lazy"
							/>
						</div>
						<div tw="bg-white p-6 w-2/3">
							<Dialog.Title tw="font-display font-bold text-2xl text-gray-700 mb-6">
								Upgrade your purchase to a Dolphin S150 Robotic Pool Cleaner!
							</Dialog.Title>
							<Dialog.Description tw="text-lg mb-4">
								Forget about scrubbing floors and walls in your pool – the S150
								does it for you!{' '}
								<b>
									PLUS a FREE Caddy, Caddy Cover, 1 Yr Extended Warranty &
									Delivery!
								</b>
							</Dialog.Description>
							<ul tw="list-disc mb-4 ml-4">
								<li>FREE Caddy (RRP $354)</li>
								<li>FREE Caddy Cover (RRP $113)</li>
								<li>FREE 1 YR Extended Warranty (RRP $102)</li>
								<li>FREE Delivery (RRP $20)</li>
							</ul>
							<p tw="mb-4">
								**<b>Online exclusive offer. Limited time.</b>**
							</p>
							<div tw="flex flex-col md:flex-row space-y-4 md:space-x-4 md:space-y-0">
								<Button
									onClick={() => {
										setPromo150(false)
										navigate('/product/dolphin-s-150-bonus')
									}}
								>
									Upgrade Now
								</Button>
								<Button
									onClick={() => {
										addToCart(value)
										onAddToCart(value, 'Category List')
										openCart()
										setPromo150(false)
									}}
									tw="bg-white hover:bg-white hover:text-gray-700"
								>
									Continue with S 100 purchase
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Dialog>
			<Dialog
				open={promo250}
				onClose={() => setPromo250(false)}
				tw="fixed z-10 inset-0 overflow-y-auto"
			>
				<div tw="flex items-center justify-center min-h-screen">
					<Dialog.Overlay tw="fixed inset-0 bg-black opacity-50" />
					<div
						className="prose"
						tw="relative bg-blue-500 flex rounded-lg items-center mx-6 overflow-hidden"
					>
						<div tw="w-1/3 p-6">
							<img
								src="https://images.ctfassets.net/ftcnv5up9dxv/36uKN4syHo0e3bmvQPB3aF/25f6d43901c1b750c100984ea5b6c378/SModel_Upsell_SocialOnline_D1.png"
								alt="Dolphin S250 Bonus Pack"
								loading="lazy"
							/>
						</div>
						<div tw="bg-white p-6 w-2/3">
							<Dialog.Title tw="font-display font-bold text-2xl text-gray-700 mb-6">
								Upgrade your purchase to a Dolphin S250 Robotic Pool Cleaner!
							</Dialog.Title>
							<Dialog.Description tw="text-lg mb-4">
								Forget about scrubbing floors and walls in your pool – the S250
								does it for you!{' '}
								<b>
									PLUS a FREE Caddy, Caddy Cover, 1 Yr Extended Warranty &
									Delivery!
								</b>
							</Dialog.Description>
							<ul tw="list-disc mb-4 ml-4">
								<li>FREE Caddy (RRP $354)</li>
								<li>FREE Caddy Cover (RRP $113)</li>
								<li>FREE 1 YR Extended Warranty (RRP $102)</li>
								<li>FREE Delivery (RRP $20)</li>
							</ul>
							<p tw="mb-4">
								**<b>Online exclusive offer. Limited time.</b>**
							</p>
							<div tw="flex flex-col md:flex-row space-y-4 md:space-x-4 md:space-y-0">
								<Button
									onClick={() => {
										setPromo150(false)
										navigate('/product/dolphin-s-250-bonus')
									}}
								>
									Upgrade Now
								</Button>
								<Button
									onClick={() => {
										addToCart(value)
										onAddToCart(value, 'Category List')
										openCart()
										setPromo150(false)
									}}
									tw="bg-white hover:bg-white hover:text-gray-700"
								>
									Continue with S 150 purchase
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Dialog>
		</ProductInfoContainer>
	)
}

export default ProductInfo

ProductInfo.propTypes = {
	imageArray: PropTypes.array,
	brand: PropTypes.string,
	series: PropTypes.string,
	model: PropTypes.string,
	price: PropTypes.string,
	sku: PropTypes.string,
	categories: PropTypes.array,
	shippingClass: PropTypes.string,
	slug: PropTypes.string,
	val: PropTypes.string,
	feature: PropTypes.array,
	specifications: PropTypes.object,
	brochure: PropTypes.string,
	manual: PropTypes.string,
	msds: PropTypes.string,
	warrantyDownload: PropTypes.string,
	distinction: PropTypes.string,
	tags: PropTypes.array,
	brandPage: PropTypes.object,
	title: PropTypes.string,
	comparisonitem: PropTypes.bool,
	seriesPageDetails: PropTypes.object,
	degreeView: PropTypes.string,
	zoom: PropTypes.object,
	active: PropTypes.bool,
	instock: PropTypes.bool,
	comingSoon: PropTypes.bool,
	linkto: PropTypes.string,
	checkedLocale: PropTypes.string,
	currency: PropTypes.string,
	locale: PropTypes.string,
}
